import swiperSlideshow from "./components/swiperSlideshow.js";
import lesalert from "./components/alert.js";
import sidescroll from "./components/sidescroll.js";
import animatedDetails from "./components/animated-details.js";
import { Loader } from "@googlemaps/js-api-loader";

class App {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "App";
		this.init();
	}

	init() {
		this.initAlert();
		this.headerFuncs();
		this.initSidescroll();
		this.initSwiperSliders();
		this.initAnimatedDetails();
		this.scrollUX();
		this.initButtons();
		this.initAnchorScroll();
		this.initMaps();
	}

	initAlert() {
		const alertEls = document.querySelectorAll(".alert-wrap");
		if (alertEls.length > 0) {
			alertEls.forEach((el) => {
				const alertEl = new lesalert({ $el: el });
			});
		}
	}
	headerFuncs() {
		const menuToggle = document.querySelector(".menu-toggle");
		if (menuToggle) {
			menuToggle.addEventListener("click", () => {
				document.body.classList.toggle("menu-open");
			});
		}
	}

	initMaps() {
		// foreach .chips-googlemap, create a google map embed
		const mapEls = document.getElementById("chipsmap");
		if (mapEls) {
			// mapEls.forEach((el) => {
			// 	const loc = el.getAttribute("data-loc");
			// 	// create a google map api embed, using api key AIzaSyDLLGZgSrPx3nZBdxTej_Oy78-lDY-Xlj0 and the loc for the location
			// });
			const mapLoc = mapEls.getAttribute("data-loc");
			const mapLink = mapEls.getAttribute("data-mapslink");
			// get the ?query value from mapLink
			const query = mapLink.split("query=")[1];
			const lat = query.split("%2C")[0];
			const lng = query.split("%2C")[1];
			// console.log(lat, lng);

			const loader = new Loader({
				apiKey: "AIzaSyDLLGZgSrPx3nZBdxTej_Oy78-lDY-Xlj0",
				version: "weekly",
			});

			loader.load().then(async () => {
				const { Map } = await google.maps.importLibrary("maps");

				var latlng = new google.maps.LatLng(lat, lng);

				let map = new Map(document.getElementById("chipsmap"), {
					disableDefaultUI: true,
					center: latlng,
					zoom: 15,
					// use a different map style
					styles: [
						{
							featureType: "landscape",
							elementType: "geometry",
							stylers: [
								{
									color: "#fdfcf7",
								},
							],
						},
						{
							featureType: "landscape",
							elementType: "geometry.fill",
							stylers: [
								{
									color: "#fdfcf7",
								},
							],
						},
						{
							featureType: "landscape.man_made",
							elementType: "geometry.fill",
							stylers: [
								{
									color: "#fdfcf7",
								},
							],
						},
						{
							featureType: "landscape.natural",
							elementType: "geometry.fill",
							stylers: [
								{
									color: "#d5f4cd",
								},
							],
						},
						{
							featureType: "landscape.natural.landcover",
							elementType: "geometry.fill",
							stylers: [
								{
									color: "#d1f0d5",
								},
							],
						},
						{
							featureType: "landscape.natural.terrain",
							elementType: "geometry",
							stylers: [
								{
									color: "#cceace",
								},
							],
						},
						{
							featureType: "landscape.natural.terrain",
							elementType: "geometry.fill",
							stylers: [
								{
									color: "#cceace",
								},
							],
						},
						{
							featureType: "poi",
							elementType: "labels",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "poi.attraction",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "poi.business",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "poi.government",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "poi.medical",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "poi.park",
							elementType: "geometry.fill",
							stylers: [
								{
									color: "#d5f4cd",
								},
							],
						},
						{
							featureType: "poi.place_of_worship",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "poi.school",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "poi.sports_complex",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road",
							elementType: "geometry.fill",
							stylers: [
								{
									color: "#dedfdd",
								},
							],
						},
						{
							featureType: "road",
							elementType: "geometry.stroke",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road",
							elementType: "labels",
							stylers: [
								{
									color: "#cbcbbe",
								},
							],
						},
						{
							featureType: "road",
							elementType: "labels.text.fill",
							stylers: [
								{
									color: "#a5a597",
								},
							],
						},
						{
							featureType: "road",
							elementType: "labels.text.stroke",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road.arterial",
							elementType: "geometry.fill",
							stylers: [
								{
									weight: 1.5,
								},
							],
						},
						{
							featureType: "road.arterial",
							elementType: "geometry.stroke",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road.arterial",
							elementType: "labels.icon",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road.highway",
							elementType: "geometry.fill",
							stylers: [
								{
									weight: 1.5,
								},
							],
						},
						{
							featureType: "road.highway",
							elementType: "labels",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road.highway",
							elementType: "labels.icon",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road.highway.controlled_access",
							elementType: "labels",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road.local",
							elementType: "geometry.fill",
							stylers: [
								{
									weight: 1,
								},
							],
						},
						{
							featureType: "road.local",
							elementType: "geometry.stroke",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "road.local",
							elementType: "labels.icon",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "transit",
							elementType: "geometry.stroke",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
						{
							featureType: "transit",
							elementType: "labels",
							stylers: [
								{
									color: "#81b3ea",
								},
							],
						},
						{
							featureType: "transit",
							elementType: "labels.text.fill",
							stylers: [
								{
									color: "#4988ca",
								},
							],
						},
						{
							featureType: "transit",
							elementType: "labels.text.stroke",
							stylers: [
								{
									visibility: "off",
								},
							],
						},
					],
				});
				let marker = new google.maps.Marker({
					position: latlng,
					map: map,
					icon: "/wp-content/themes/lesecologycenter/assets/map-marker.svg",
				});
			});
		}
	}
	scrollUX() {
		const pageMap = document.querySelector(".embed-wrap");
		if (pageMap) {
			// when the mousewheel is scrolled on the document, if the mouse is over the map, prevent the scroll from happening
			// document.addEventListener("wheel", (e) => {

			// });
			pageMap.addEventListener("click", () => {
				pageMap.classList.add("interactive");
			});
		}

		window.addEventListener("scroll", () => {
			if (window.scrollY > 120) {
				document
					.querySelector("header.les-header")
					.classList.add("scrolled");
			} else {
				document
					.querySelector("header.les-header")
					.classList.remove("scrolled");
			}
		});
	}
	initButtons() {
		const buttonsArrowR = document.querySelectorAll(
			".button-arrow-r,.wyg .btn-inline,.component-eventdetails .btn-inline"
		);
		if (buttonsArrowR.length > 0) {
			buttonsArrowR.forEach((el) => {
				// append svg `<svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.478 10.001 7.886 2.408 9.3.994l9.299 9.299.707.707-.707.707-9.3 9.299-1.413-1.414L15.476 12H0v-2h15.478Z" fill="#185633"/></svg>`
				el.innerHTML += `<svg viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.478 10.001 7.886 2.408 9.3.994l9.299 9.299.707.707-.707.707-9.3 9.299-1.413-1.414L15.476 12H0v-2h15.478Z" fill="#185633"/></svg>`;
			});
		}
	}
	initSidescroll() {
		const SidescrollEls = document.querySelectorAll(".overscroll-anchors");
		if (SidescrollEls.length > 0) {
			SidescrollEls.forEach((el) => {
				const SidescrollEl = new sidescroll({ $el: el });
			});
		}
	}
	initSwiperSliders() {
		const swiperEls = document.querySelectorAll(".component-carousel");
		if (swiperEls.length <= 0) {
			return;
		}
		swiperEls.forEach((el) => {
			const swiper = new swiperSlideshow({ $el: el });
		});
	}
	initAnimatedDetails() {
		const aniDetailsEls = document.querySelectorAll(".animated-details");
		if (aniDetailsEls.length <= 0) {
			return;
		}
		aniDetailsEls.forEach((el) => {
			const aniDetail = new animatedDetails({ $el: el });
		});
	}
	initAnchorScroll() {
		if (!document.querySelector(".section-page_links")) {
			return;
		}

		this.setAnchorScrollPos();
		window.addEventListener("resize", () => {
			this.setAnchorScrollPos();
		});
		this.watchAnchorScroll();
	}
	setAnchorScrollPos() {
		this.anchorLinks = document.querySelectorAll(".section-page_links a");
		if (this.anchorLinks.length <= 0) {
			return;
		}

		this.anchorLinkTargets = [];
		this.anchorLinks.forEach((link) => {
			const targetId = link.getAttribute("href");
			const targetEl = document.querySelector(
				"[name=" + targetId.replace("#", "") + "]"
			);
			if (targetEl) {
				link.addEventListener("click", (e) => {
					e.preventDefault();
					window.scrollTo(0, targetEl.parentElement.offsetTop - 155);
					window.location.hash = targetId;
					document.body.classList.add("disable-pointer-events");
					setTimeout(() => {
						document.body.classList.remove(
							"disable-pointer-events"
						);
					}, 500);
				});
				const targetOffset = targetEl.parentElement.offsetTop;

				this.anchorLinkTargets.push({
					id: targetId,
					offset: targetOffset,
				});
			}
		});
		// console.log(this.anchorLinkTargets);
	}
	watchAnchorScroll() {
		window.addEventListener("scroll", () => {
			// console.log(this.anchorLinkTargets);
			if (!this.anchorLinkTargets || this.anchorLinkTargets.length <= 0) {
				return;
			}
			const scrollY = window.scrollY;
			this.anchorLinkTargets.forEach((target) => {
				if (scrollY >= target.offset - 160) {
					// console.log(target);
					this.anchorLinks.forEach((link) => {
						if (link.getAttribute("href") === target.id) {
							link.classList.add("active");
							// scroll .component-pagenav .overscroll-anchors to active link
							const overscrollAnchors = document.querySelector(
								".component-pagenav .overscroll-anchors"
							);
							// if (overscrollAnchors) {
							// 	setTimeout(() => {
							// 		overscrollAnchors.scrollTo({
							// 			left: link.offsetLeft - 60,
							// 		});
							// 	}, 1000);
							// }
						} else {
							link.classList.remove("active");
						}
					});
				}
			});
		});
	}
}

const app = new App();
